import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el ebook?',
  a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con el enlace para descargar el manual en formato PDF de alta calidad. Podés leerlo en tu celular, tablet o computadora.'
}, {
  q: '¿Es seguro el pago?',
  a: 'Totalmente. El pago se procesa a través de una plataforma segura y encriptada. Tus datos financieros nunca son compartidos con nosotros.'
}, {
  q: '¿Sirve si estoy soltero/a?',
  a: 'Sí, absolutamente. Gran parte del manual se enfoca en el autoconocimiento relacional y en sanar patrones propios. Es una preparación excelente para tu próxima relación.'
}, {
  q: '¿Y si mi pareja no quiere leerlo?',
  a: 'No hay problema. Cuando una parte de la pareja cambia su forma de comunicarse y reaccionar, el sistema completo se ve obligado a cambiar. Podés aplicar las herramientas individualmente y ver resultados en la dinámica.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí, tenés 7 días de garantía. Si sentís que el material no te aporta valor, te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  q: '¿Es un curso en video?',
  a: 'No, es un manual digital (Ebook) escrito. Está diseñado para que puedas leerlo a tu ritmo, volver a las secciones que necesites y hacer los ejercicios por escrito.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section background="primary" data-id="element-59">
      <div className="text-center mb-16" data-id="element-60">
        <h2 className="font-serif text-3xl md:text-4xl text-white" data-id="element-61">
          Preguntas frecuentes
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-62">
        {faqs.map((faq, index) => <div key={index} className="bg-navy-800 rounded-xl border border-navy-border overflow-hidden" data-id="element-63">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-navy-700 transition-colors" data-id="element-64">
              <span className="font-medium text-white text-lg pr-4" data-id="element-65">
                {faq.q}
              </span>
              {openIndex === index ? <ChevronUp className="text-accent flex-shrink-0" data-id="element-66" /> : <ChevronDown className="text-accent flex-shrink-0" data-id="element-67" />}
            </button>

            <AnimatePresence data-id="element-68">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-69">
                  <div className="px-6 pb-6 text-muted leading-relaxed pt-2" data-id="element-70">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}